import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  Button,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
} from "@material-ui/core"
import { Link, withRouter, useParams, Redirect, Prompt } from "react-router-dom"
import moment from "moment"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import * as IssueActions from "../actions/IssueActions"
import axios from "axios"

const useStyles = makeStyles({
  root: {
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  formControl: {
    minWidth: 350,
  },
})

const EditIssue = (props) => {
  const classes = useStyles()
  const { id } = useParams()

  const [isDirty, setIsDirty] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)
  const [issue, setIssue] = React.useState({})

  React.useEffect(() => {
    setIsLoading(true)
    const getIssue = async () => {
      const res = await axios.get(
        `https://my-json-server.typicode.com/yash0patni/issue_tracker_server/issues/${id}`
      )
      setIssue(res.data)
      setIsLoading(false)
    }

    getIssue()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChange = (event) => {
    setIssue({ ...issue, [event.target.name]: event.target.value })
  }

  const onSubmit = (event) => {
    setIsDirty(false)
    event.preventDefault()

    const updatedIssue = {
      id: issue.id,
      description: issue.description,
      severity: issue.severity,
      status: issue.status,
      createdDate: issue.createdDate,
      lastUpdated: moment().format("MMMM Do YYYY"),
      resolvedDate:
        issue.status === "Closed" ? moment().format("MMMM Do YYYY") : null,
      loggedBy: issue.loggedBy,
      lastUpdatedBy: props.users.id,
      loggedByName: issue.loggedByName,
      lastUpdatedByName: props.users.firstName + " " + props.users.lastName,
    }
    //console.log(updatedIssue);
    props.actions.editIssue(updatedIssue)
    props.history.push("/issue-tracker/issues")
  }

  if (!props.users.isAuthenticated) {
    return <Redirect to="/issue-tracker/" />
  }

  return isLoading ? (
    <p>Loading...</p>
  ) : (
    <div className={classes.root}>
      <Link to="/issue-tracker/issues">Back</Link>
      <h2>Edit Issue</h2>
      <form
        onSubmit={onSubmit}
        onChange={() => setIsDirty(true)}
        autoComplete="off"
      >
        <TextField
          className={classes.formControl}
          id="description"
          label="Description"
          name="description"
          value={issue.description}
          onChange={handleChange}
        />
        <br></br>
        <br></br>
        <FormControl className={classes.formControl}>
          <InputLabel id="severity">Severity</InputLabel>
          <Select
            labelId="Severity"
            id="severity"
            name="severity"
            value={issue.severity}
            onChange={handleChange}
          >
            <MenuItem key="1" value={"Critical"}>
              Critical
            </MenuItem>
            <MenuItem key="2" value={"Major"}>
              Major
            </MenuItem>
            <MenuItem key="3" value={"Minor"}>
              Minor
            </MenuItem>
          </Select>
        </FormControl>
        <br></br>
        <br></br>
        <br></br>
        <FormControl component="fieldset">
          <FormLabel component="legend">Status</FormLabel>
          <RadioGroup
            aria-label="Status"
            name="status"
            value={issue.status}
            onChange={handleChange}
          >
            <FormControlLabel value="Open" control={<Radio />} label="Open" />
            <FormControlLabel
              value="In Progress"
              control={<Radio />}
              label="In Progress"
            />
            <FormControlLabel
              value="Closed"
              control={<Radio />}
              label="Closed"
            />
          </RadioGroup>
        </FormControl>
        <br></br>
        <br></br>
        <Button
          fullWidth
          onClick={() => setIsDirty(false)}
          type="submit"
          variant="contained"
          color="primary"
        >
          Save
        </Button>
      </form>
      <Prompt
        when={isDirty}
        message="All changes will be lost, Are you sure you want to continue ?"
      />
    </div>
  )
}

function mapStateToProps(state) {
  return {
    issues: state.issues,
    users: state.users,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(IssueActions, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(EditIssue))
